import { render, staticRenderFns } from "./RequestKitsThanksHero.vue?vue&type=template&id=10a5027b&scoped=true"
import script from "./RequestKitsThanksHero.vue?vue&type=script&lang=js"
export * from "./RequestKitsThanksHero.vue?vue&type=script&lang=js"
import style0 from "./RequestKitsThanksHero.vue?vue&type=style&index=0&id=10a5027b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a5027b",
  null
  
)

export default component.exports